import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum.js';
import TpEvaluatorLinkItem from '../../../Domain/TpEvaluatorLinkItem.js';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable.js';
import TpEvaluatorLinkService from '../../../Services/TpEvaluatorLinkService.js';
import TpEvaluatorLinkSearchParams from './TpEvaluatorLinkSearchParams.js';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum.js';
import GenericOverWindow from '../../../Elements/TabList/GenericOverWindow.js';
import RelatedTpJobWindowDescription from './RelatedTpJobWindowDescription.js';

export default class TpEvaluatorLinkAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const { tpEvaluatorId } = props;
    // TpEvaluatorItem.ignoreFunction = (id, item) => this.ignoreFunctionApprove(id, item);
    // TpEvaluatorItem.activateFunction = (id, item) => this.activateFunctionApprove(id, item);
    // TpEvaluatorItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    // TpEvaluatorItem.selectedStatus = this.selectedStatus.bind(this);
    // TpEvaluatorItem.clickOnSelect = this.clickOnSelect.bind(this);

    this.state = {
      searchItem: new TpEvaluatorLinkSearchParams(tpEvaluatorId),
      itemList: [],
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);

    TpEvaluatorLinkItem.ListJobsFunction = this.ListJobsFunction.bind(this);
    RelatedTpJobWindowDescription.getFilterParameters = this.getRelatedJobsFilterParameters.bind(this);
    // The rows are the primary's own records plus those of the profiles linked under it; the Type column
    // (Master/Slave) needs to know which primary this tab was opened for.
    TpEvaluatorLinkItem.primaryTpEvaluatorId = tpEvaluatorId;
  }

  // clickOnSelect(item, selected) {
  //   item.Selected = selected;
  //   const templist = [...this.state.itemList];
  //   templist.forEach((element) => {
  //     if (element.TpDataExportExcludedItemId === item.TpDataExportExcludedItemId) {
  //       element.Selected = selected;
  //     }
  //   });
  //   this.setState({ itemList: templist });
  // }

  // selectAllElements() {
  //   const selectedStatus = this.state.itemList.some((item) => item.Selected === false);

  //   const templist = [...this.state.itemList];

  //   if (templist !== undefined && templist.length > 0) {
  //     templist.map((c) => (c.Selected = selectedStatus));
  //   }
  //   this.setState({ itemList: templist });
  // }

  // selectedStatus() {
  //   return !this.state.itemList.some((x) => x.Selected === false);
  // }

  // activateFunction(id) {
  //   TpEvaluatorLinkService.ActivateItem(id)
  //     .then(() => this.refresh())
  //     .catch(() => ErrorMessage.SetErrorMessage('TDEEA65'));
  // }

  getRelatedJobsFilterParameters() {
    return {
      tpEvaluatorLinkId: this.state.selectedItem?.TpEvaluatorLinkId,
      evaluatorId: this.state.selectedItem?.EvaluatorId,
      name: this.state.selectedItem?.Name,
    };
  }

  ListJobsFunction(item) {
    this.setState({
      selectedItem: item,
      shownOverWindow: ShownOverWindowsEnum.AssignmentsList,
    });
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.AssignmentsList) {
      return (
        <GenericOverWindow
          windowDescription={RelatedTpJobWindowDescription}
          filterParameters={this.getRelatedJobsFilterParameters()}
          clickOnCancel={() => this.setState({ shownOverWindow: ShownOverWindowsEnum.None })}
        />
      );
    }

    return null;
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  render() {
    // Re-bound on every render on purpose (same as the row-action statics): the popup can move to another
    // evaluator without remounting this tab.
    TpEvaluatorLinkItem.primaryTpEvaluatorId = this.props.tpEvaluatorId;
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          clickOnStartSearch={this.startSearch}
          searchParamsType={TpEvaluatorLinkSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={false}
          serviceFunction={TpEvaluatorLinkService.GetAllItemBySearching}
          convertDBItemsFunction={TpEvaluatorLinkService.ConvertDBItems}
          shownPanel={this.state.shownPanel}
          type={TpEvaluatorLinkItem}
          popupEnabled={true}
          singleSearchLine={false}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='TELA134'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
        />
        {this.renderOverWindows()}
      </div>
    );
  }
}
